import { render, staticRenderFns } from "./ConnectedApp.vue?vue&type=template&id=5fe5b8f8"
import script from "./ConnectedApp.vue?vue&type=script&lang=js"
export * from "./ConnectedApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports